<div class="mt-3" *ngIf="!isViewMode && isShowImportShelfButton">
  <app-upload-document-button
    #importShelf
    id="importShelf"
    data-id="importShelf"
    [allowedTypes]="'sheet'"
    [withMeta]="false"
    [multiple]="false"
    [size]="50000000"
    [allowedExt]="'xlsx'"
    [uploadUrl]="importBarcodeUrl"
    [uploadHeaders]="importHeaders"
    (itemDetail)="onLoadItemDetail($event)"
    [isExistingUpload]="formControls.length > 0"
    [text]="'Import Shelf'"
    class="d-none"
    [metricsReq]="metricsRequest"
  >
  </app-upload-document-button>
</div>
<div class="mt-3" *ngIf="!isViewMode && isShowImportItemButton">
  <app-upload-document-button
    #importItem
    id="importItem"
    data-id="importItem"
    [allowedTypes]="'sheet'"
    [withMeta]="false"
    [multiple]="false"
    [size]="50000000"
    [allowedExt]="'xlsx'"
    [uploadUrl]="importFirstLot"
    [uploadHeaders]="importHeaders"
    (itemDetail)="onLoadFirstLotItemDetail($event)"
    [isExistingUpload]="formControls.length > 0"
    [text]="'Import Item'"
    class="d-none"
    [metricsReq]="metricsRequest"
  >
  </app-upload-document-button>
</div>
<app-import-export-button
  [buttons]="buttons"
  (export)="onExport()"
  (import)="onClickImport($event)"
></app-import-export-button>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="shelf-inventory-table">
      <table
        id="inventoryTable"
        data-id="inventoryTable"
        class="table table-striped table-bordered w-100 shelf-inventory-table-scroll"
        [formGroup]="parentForm"
        *ngIf="formControls.length > 0"
        aria-label="inventoryTable"
      >
        <thead>
          <tr>
            <th class="text-center w-15" scope="col">{{ headerRow[0] }}</th>
            <th class="text-center w-10" scope="col">{{ headerRow[1] }}</th>
            <th class="text-center w-5" scope="col">{{ headerRow[2] }}</th>
            <th class="text-center w-10" scope="col">{{ headerRow[3] }}<span class="text-danger">*</span></th>
            <th class="text-center w-5" scope="col">{{ headerRow[4] }}<span class="text-danger">*</span></th>
            <th class="text-center w-5" scope="col">{{ headerRow[5] }}<span class="text-danger">*</span></th>
            <th class="text-center w-5" scope="col">{{ headerRow[6] }}<span class="text-danger">*</span></th>
            <th class="text-center w-5" scope="col">{{ headerRow[7] }}<span class="text-danger">*</span></th>
            <th class="text-center w-5" scope="col">{{ headerRow[8] }}<span class="text-danger">*</span></th>
            <th class="text-center w-10" scope="col">{{ headerRow[9] }}<span class="text-danger">*</span></th>
            <th class="text-center w-5" *ngIf="hasEditPermission" scope="col">{{ headerRow[10] }}</th>
            <th class="text-center w-5" *ngIf="isShowChangesMode" scope="col">{{ headerRow[11] }}</th>
          </tr>
        </thead>
        <tbody formArrayName="inventoryItem">
          <tr
            *ngFor="let item of paging.currentPageData; index as i"
            [formGroupName]="i + (currentPage - 1) * pageSize"
            [ngClass]="{
              'error-background':
                item.errors?.invalidBarcode ||
                item.errors?.isInactive ||
                item.errors?.isStatusDelisted ||
                item.errors?.isFixAssetItem ||
                item.errors?.isStoreUseItem ||
                (item.errors?.duplicated && mode !== requestPageModesEnum.REQUEST_VIEW)
            }"
          >
            <td class="text-left align-top">
              {{ item.get('productName').value }}
              <span class="d-block">{{ item.get('articleNo').value }}</span>
              <span class="d-block invalid-feedback text-danger" *ngIf="item.errors?.isStatusDelisted">
                {{ 'ERRORS.STATUS_IS_DELISTED' | translate }}
              </span>
              <span class="d-block invalid-feedback text-danger" *ngIf="item.errors?.isFixAssetItem">
                {{ 'ERRORS.NOT_ALLOW_FIX_ASSET' | translate }}
              </span>
              <span class="d-block invalid-feedback text-danger" *ngIf="item.errors?.isStoreUseItem">
                {{ 'ERRORS.NOT_ALLOW_STORE_USE' | translate }}
              </span>
            </td>
            <td class="text-left align-top">
              {{ item.get('barcode').value }}

              <span class="d-block invalid-feedback text-danger" *ngIf="item.errors?.invalidBarcode">
                {{ 'ERRORS.INVALID_BARCODE' | translate }}
              </span>
              <span class="d-block invalid-feedback text-danger" *ngIf="item.errors?.isInactive">
                {{ 'ERRORS.INACTIVE_BARCODE' | translate }}
              </span>
              <span
                class="d-block invalid-feedback text-danger"
                *ngIf="item.errors?.duplicated && mode !== requestPageModesEnum.REQUEST_VIEW"
              >
                {{ 'ERRORS.DUPLICATED_BARCODE_FIELD' | translate }}
              </span>
            </td>

            <td class="text-center align-top">
              <span *ngIf="item.get('unitFactor').value && item.get('unit').value">
                {{ item.get('unit').value }}<br />
                ({{ item.get('unitFactor').value }} {{ item.get('baseUnit').value }})
              </span>
            </td>
            <td class="text-center align-top">
              <div class="bay-no-level">
                <div>
                  <app-numeric-textbox
                    class="td-numeric-textbox-center"
                    [ngClass]="{
                      'is-invalid': submitted && validatorFormControls('bayNo', i),
                      'd-none':
                        item.errors &&
                        !(item.errors?.required && item.errors?.isZero) &&
                        !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                        !item.errors?.duplicatedLocationId,
                      'bg-h-change': hasChanges(item, 'bayNo')
                    }"
                    formControlName="bayNo"
                    [format]="'0'"
                    [minValue]="1"
                    [maxValue]="99"
                    id="bayNo"
                    data-id="bayNo"
                    maxlength="2"
                    placeholder="0"
                  >
                  </app-numeric-textbox>

                  <div
                    class="invalid-display text-danger"
                    *ngIf="submitted && !item.errors && validatorFormControls('bayNo', i)"
                  >
                    <div *ngIf="validatorFormControls('bayNo', i)?.required">
                      <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                    </div>

                    <div *ngIf="validatorFormControls('bayNo', i).isZero">
                      <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="
                    !item.errors || (item.errors?.duplicatedLocationId && mode !== requestPageModesEnum.REQUEST_VIEW)
                  "
                >
                  /
                </div>
                <div>
                  <app-bay-level-textbox
                    class="td-numeric-textbox-center"
                    [ngClass]="{
                      'is-invalid': submitted && validatorFormControls('bayLevel', i),
                      'd-none':
                        item.errors &&
                        !(item.errors?.required && item.errors?.isZero) &&
                        !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                        !item.errors?.duplicatedLocationId,
                      'bg-h-change': hasChanges(item, 'bayLevel')
                    }"
                    formControlName="bayLevel"
                    [minValue]="1"
                    [maxValue]="99.99"
                    id="bayLevel"
                    data-id="bayLevel"
                    maxlength="5"
                    placeholder="0"
                  >
                  </app-bay-level-textbox>

                  <div
                    class="invalid-display text-danger"
                    *ngIf="submitted && !item.errors && validatorFormControls('bayLevel', i)"
                  >
                    <div *ngIf="validatorFormControls('bayLevel', i)?.required">
                      <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                    </div>

                    <div *ngIf="validatorFormControls('bayLevel', i).isZero">
                      <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="invalid-display text-danger"
                *ngIf="submitted && item.errors && validatorFormControls('bayNo', i)"
              ></div>
            </td>
            <td class="text-center align-top">
              <app-numeric-textbox
                class="td-numeric-textbox-center"
                [ngClass]="{
                  'is-invalid': submitted && validatorFormControls('locationId', i),
                  'd-none':
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId,
                  'bg-h-change': hasChanges(item, 'locationId')
                }"
                formControlName="locationId"
                [format]="'0,0.[00]'"
                [minValue]="1"
                [maxValue]="999"
                id="locationId"
                data-id="locationId"
                maxlength="3"
                placeholder="Quantity"
              >
              </app-numeric-textbox>
              <div
                class="invalid-display text-danger"
                *ngIf="
                  submitted &&
                  !(
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId
                  ) &&
                  validatorFormControls('locationId', i)
                "
              >
                <div *ngIf="validatorFormControls('locationId', i)?.required">
                  <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                </div>

                <div *ngIf="validatorFormControls('locationId', i)?.isZero">
                  <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                </div>

                <div *ngIf="validatorFormControls('locationId', i)?.duplicatedLocationId">
                  <span>{{ 'ERRORS.DUPLICATED_LOCATION_ID' | translate }}</span>
                </div>
              </div>
            </td>
            <td class="text-center align-top">
              <app-numeric-textbox
                class="td-numeric-textbox-center"
                [ngClass]="{
                  'is-invalid': submitted && validatorFormControls('facingQty', i),
                  'd-none':
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId,
                  'bg-h-change': hasChanges(item, 'facingQty')
                }"
                formControlName="facingQty"
                [format]="'0,0.[00]'"
                [minValue]="1"
                [maxValue]="99"
                id="facingQty"
                data-id="facingQty"
                maxlength="2"
                (blur)="calculateGradingQty(item)"
                placeholder="Quantity"
              >
              </app-numeric-textbox>
              <div
                class="invalid-display text-danger"
                *ngIf="
                  submitted &&
                  !(
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId
                  ) &&
                  validatorFormControls('facingQty', i)
                "
              >
                <div *ngIf="validatorFormControls('facingQty', i)?.required">
                  <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                </div>

                <div *ngIf="validatorFormControls('facingQty', i).isZero">
                  <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                </div>
              </div>
            </td>
            <td class="text-center align-top">
              <app-numeric-textbox
                class="td-numeric-textbox-center"
                [ngClass]="{
                  'is-invalid': submitted && validatorFormControls('stackingQty', i),
                  'd-none':
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId,
                  'bg-h-change': hasChanges(item, 'stackingQty')
                }"
                formControlName="stackingQty"
                [format]="'0,0.[00]'"
                [minValue]="1"
                [maxValue]="99"
                id="stackingQty"
                data-id="stackingQty"
                maxlength="2"
                (blur)="calculateGradingQty(item)"
                placeholder="Quantity"
              >
              </app-numeric-textbox>

              <div
                class="invalid-display text-danger"
                *ngIf="
                  submitted &&
                  !(
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId
                  ) &&
                  validatorFormControls('stackingQty', i)
                "
              >
                <div *ngIf="validatorFormControls('stackingQty', i)?.required">
                  <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                </div>

                <div *ngIf="validatorFormControls('stackingQty', i).isZero">
                  <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                </div>
              </div>
            </td>
            <td class="text-center align-top">
              <app-numeric-textbox
                class="td-numeric-textbox-center"
                [ngClass]="{
                  'is-invalid': submitted && validatorFormControls('depthQty', i),
                  'd-none':
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId,
                  'bg-h-change': hasChanges(item, 'depthQty')
                }"
                formControlName="depthQty"
                [format]="'0,0.[00]'"
                [minValue]="1"
                [maxValue]="99"
                id="depthQty"
                data-id="depthQty"
                maxlength="2"
                (blur)="calculateGradingQty(item)"
                placeholder="Quantity"
              >
              </app-numeric-textbox>

              <div
                class="invalid-display text-danger"
                *ngIf="
                  submitted &&
                  !(
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId
                  ) &&
                  validatorFormControls('depthQty', i)
                "
              >
                <div *ngIf="validatorFormControls('depthQty', i)?.required">
                  <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                </div>

                <div *ngIf="validatorFormControls('depthQty', i).isZero">
                  <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                </div>
              </div>
            </td>
            <td class="text-center align-top">
              <app-numeric-textbox
                class="td-numeric-textbox-center"
                [ngClass]="{
                  'is-invalid': submitted && validatorFormControls('maxRefillQuantity', i),
                  'd-none':
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId,
                  'bg-h-change': hasChanges(item, 'maxRefillQuantity')
                }"
                formControlName="maxRefillQuantity"
                [format]="'0'"
                [minValue]="1"
                [maxValue]="99"
                placeholder="Quantity"
                id="maxRefillQuantity"
                data-id="maxRefillQuantity"
                maxlength="2"
                [allowPaste]="false"
                [negativeSign]="false"
              >
              </app-numeric-textbox>

              <div
                class="invalid-display text-danger"
                *ngIf="
                  submitted &&
                  !(
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId
                  ) &&
                  validatorFormControls('maxRefillQuantity', i)
                "
              >
                <div *ngIf="validatorFormControls('maxRefillQuantity', i)?.required">
                  <span> {{ 'ERRORS.REQUIRED' | translate }} </span>
                </div>

                <div *ngIf="validatorFormControls('maxRefillQuantity', i).isZero">
                  <span>{{ 'ERRORS.NOT_ALLOW' | translate: '{ value: 0 }' }}</span>
                </div>
              </div>
            </td>
            <td class="align-top">
              <ng-select
                [clearable]="false"
                [items]="fixtureTypeList"
                [searchable]="false"
                bindLabel="label"
                bindValue="value"
                formControlName="fixtureType"
                id="fixtureType"
                placeholder="Please select..."
                data-id="fixtureType"
                [ngClass]="{
                  'is-invalid': submitted && validatorFormControls('fixtureType', i),
                  'd-none':
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId,
                  'bg-h-change': hasChanges(item, 'fixtureType')
                }"
              >
              </ng-select>
              <div
                class="invalid-display text-danger"
                *ngIf="
                  submitted &&
                  !(
                    item.errors &&
                    !(item.errors?.required && item.errors?.isZero) &&
                    !(item.errors?.duplicated && mode === requestPageModesEnum.REQUEST_VIEW) &&
                    !item.errors?.duplicatedLocationId
                  ) &&
                  validatorFormControls('fixtureType', i)
                "
              >
                <div *ngIf="validatorFormControls('fixtureType', i)?.required">
                  <span>{{ 'ERRORS.REQUIRED' | translate }}</span>
                </div>
              </div>
              <div *ngIf="hasEditPermission && i === 0 && !item.errors" class="text-center mt-2">
                <a
                  (click)="applyFixtureType(form, item.get('fixtureType').value)"
                  *ngIf="i === 0"
                  class="btn-text-link"
                  href="javascript:void(0)"
                >
                  Apply All
                </a>
              </div>
            </td>
            <td class="text-center align-middle" *ngIf="hasEditPermission">
              <a class="is-link text-muted" (click)="deleteItem(i)" ngxTippy="Delete">
                <em class="icon-delete"></em>
              </a>
            </td>
            <td class="text-center align-top" *ngIf="isShowChangesMode">
              {{ 'CHANGE_STATUS.' + changeStatus(item) | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <app-ui-pagination
        #paging
        [(currentPage)]="currentPage"
        [(pageSize)]="pageSize"
        [items]="form.controls"
        [valueChangeDetector]="form.valueChanges | async"
      >
      </app-ui-pagination>

      <div class="clearfix"></div>
    </div>

    <div class="mt-2" *ngIf="isShowDeletedItemsButton">
      <span>
        Remark: <a class="btn-text-link d-inline-block mr-1" (click)="showDeletedItems()">Deleted Items List</a>
      </span>
    </div>
  </div>
</div>

<div *ngIf="hasEditPermission">
  <a class="btn-text-link d-inline-block mr-1" id="addNewItemBtn" data-id="addNewItemBtn" (click)="addNewItem()"
    >+ Select Item</a
  >
  or
  <a
    class="btn-text-link d-inline-block ml-1"
    id="addNewBarcodeBtn"
    data-id="addNewBarcodeBtn"
    (click)="addNewBarcode()"
    >+ Add Barcode</a
  >
</div>

<app-search-product-modal #searchProductModal [productType]="productType" (addItem)="onAddItem($event)">
</app-search-product-modal>

<app-search-barcode-modal #searchBarcodeModal [allowProductType]="productType" (addItem)="onAddBarcodeItem($event)">
</app-search-barcode-modal>
